import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper';
import 'swiper/css';
import 'swiper/css/free-mode';
import Link from '../Link';
import type { Banner } from '../../models/Banner';
import styles from './styles.module.scss';

type FranjaClientesProps = {
    data: Banner[]
}

const FranjaClientes = ({ data }: FranjaClientesProps) => {

  // Swiper con loop + freeMode arma el DOM distinto en cliente vs. lo que
  // se puede pre-renderizar en servidor; se difiere el montaje al cliente
  // para evitar mismatch de hidratación (mismo approach que en spiral-studio-web-next).
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  if (!data || data.length === 0) return null;

  return (
    <>
      {/* En mobile no tiene sentido hacer swipe entre pares de logos: se
                muestran todos juntos en una grilla, sin interacción necesaria.
                Ambas ramas se renderizan siempre; el toggle es puro CSS para
                no depender de un booleano "mobile" resuelto en cliente. */}
      <div className={styles.mobileOnly}>
        <div className={styles.grid}>
          {data.map((banner, i) => (
            <LogoItem key={banner.id ?? i} banner={banner} eager={i < 6} />
          ))}
        </div>
      </div>

      <div className={styles.desktopOnly}>
        {isClient && (
          <Swiper
            className={styles.swiper}
            style={{ '--swiper-wrapper-transition-timing-function': 'linear' } as React.CSSProperties}
            modules={[Autoplay, FreeMode]}
            autoplay={{ delay: 0, disableOnInteraction: false }}
            speed={6000}
            spaceBetween={20}
            slidesPerView="auto"
            freeMode={true}
            allowTouchMove={false}
            loop={true}
          >
            {data.map((banner, i) => (
              <SwiperSlide key={banner.id ?? i} className={styles.slide}>
                <LogoItem banner={banner} eager={i === 0} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </>
  );
};

export default FranjaClientes;

type LogoItemProps = {
    banner: Banner
    eager: boolean
}

const LogoItem = ({ banner, eager }: LogoItemProps) => {

  const desktopImage = banner.attributes.desktop?.data?.attributes;
  const mobileImage = banner.attributes.mobile?.data?.attributes;
  const src = desktopImage?.url || mobileImage?.url || '';
  const alt = desktopImage?.alternativeText || mobileImage?.alternativeText || 'We Celebrate';
  const href = banner.attributes.link;
  const external = !!banner.attributes.targetBlank;

  const img = <img src={src} alt={alt} loading={eager ? 'eager' : 'lazy'} />;

  return href ? (
    <Link href={href} external={external} className={styles.logo}>
      {img}
    </Link>
  ) : (
    <span className={styles.logo}>{img}</span>
  );
};
